module.exports = __webpack_public_path__ + "static/media/7-Y.e59d56b5.mp3";